import { render, staticRenderFns } from "./AdminNotification.vue?vue&type=template&id=39bf061d&scoped=true"
import script from "./AdminNotification.vue?vue&type=script&lang=js"
export * from "./AdminNotification.vue?vue&type=script&lang=js"
import style0 from "./AdminNotification.vue?vue&type=style&index=0&id=39bf061d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bf061d",
  null
  
)

export default component.exports